import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import "./log-out-modal.style.scss";
export default function LogOutModal({ closeIt }) {
  return ReactDOM.createPortal(
    <div onClick={() => closeIt()} className="log-out-modal-main">
      <div onClick={(e) => e.stopPropagation()} className="log-out-modal">
        <button onClick={() => closeIt()} className="close">
          x
        </button>
        <h4>Logged Out SuccessFully</h4>
        <img src={Images.relaxing} alt="relax" />
        <p>You have been logged out Please log back in</p>
        <Link onClick={() => closeIt()} to="/login" className="action-button">
          Login Now
        </Link>
      </div>
    </div>,
    document.body
  );
}
